<template>
<div class="navbar navbar-expand-md navbar-dark">
    <div class="navbar-brand py-1 d-flex align-items-center">
        <router-link to="/"  >
            <img alt=""   :src="$storeIndex.getImageGobalAssets('logo-goship-gosell-white')" style="height:27px;" />
        </router-link>
    </div>

    <div class="d-md-none">
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
        </button> -->
        <button class="navbar-toggler nav-user" type="button" data-toggle="collapse" data-target="#nav-user">
            <i class="icon-user"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
            <i class="icon-paragraph-justify3"></i>
        </button>
    </div>
   
    <div class="collapse navbar-collapse justify-content-end" id="nav-user">
        <ul class="navbar-nav">
            <li class="nav-item dropdown dropdown-user">
                <a href="javascript:void(0);" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
                    <avatar :username="user.first_name" :size="34" :src="user.image_url" :backgroundColor="'rgb(3, 169, 244)'" :color="'#ffffff'"></avatar>
                    <span class="pl-2">{{ user.first_name }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="{name: 'account.referfriends'}" class="dropdown-item"><i class="fas fa-users-medical"></i><span>{{ $t("Refer Friends")}}</span></router-link>
                    <a href="javascript:void(0);" @click="logout()"  class="dropdown-item"><i class="icon-switch2"></i>{{$t('Logout')}}</a>
                </div>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service'
import Api from '@/services/endpoint/tenant.service'
import Avatar from 'vue-avatar'
import Cookies from "js-cookie";
import TenantAuth from '@/services/auth.tenant.service';
import {
    localSave,
    localRead
} from "@/store/lang";

export default {
    name: "TopMenu",
    components: {
        Avatar
    },
    data() {
        return {
            lang: localRead("local"),
            localList: {
                th: "Thai",
                en: "English",
            },
            user : {
                first_name : '',
                last_name : '',
                image_url : '',
            }
        };
    },
    computed: {
        title() {
            return this.localList[this.lang];
        },
    },
    methods: {
        selectLang(lang) {
            localSave("local", lang);
            location.reload();
        },
        async logout(){
            // sessionStorage.removeItem("domain");
            if(this.$cookie.get('tenantToken')) {
                const requestTenant = await Api.Tenant.logOut();
                if(requestTenant.status != 200) console.error('logout tenant failed')

                this.$cookie.remove('tenantToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            }

            const request = await CentralApi.Auth.logOut();
            if(request.status != 200) console.error('logout central failed')
           
            Cookies.remove(`userProfile`, { domain: '.' + process.env.CENTRAL_API_ROOT })
            TenantAuth.logout()
            this.$cookie.remove('centralToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            location.href = process.env.CENTRAL_APP_URL;
        },
        async getUser() {

            const getDataStringFromCookie = () => {
                let i = 1
                let fullString = ""

                while (true) {
                  const string = Cookies.get(`userProfile-${i}`)
                  Cookies.remove(`userProfile-${i}`, { domain: '.' + process.env.CENTRAL_API_ROOT })
                  if(!string) break
                  fullString = fullString + string
                  
                  i++
                }
                
                if(!fullString) return {
                  message : "full string is empty"
                }

                let user = JSON.parse(fullString) 

                const shortUser = {
                  i : "id",
                  gi : "global_id",
                  fn : "first_name"  ,
                  ln : "last_name",  
                  e : "email",  
                  m : "mobile"  ,
                  s : "store_limit",
                  u : "user_data",  
                }
               
                const formatuser = {}
                for (const [key, value] of Object.entries(user)) {
                  formatuser[shortUser[key]] = value
                }
               
                return formatuser
            }

            const user = getDataStringFromCookie()

            let data = {}

            if('id' in user) {
                data = {
                    data: {
                        data : user
                    }
                }

                Cookies.set('userProfile', JSON.stringify(data.data.data), { domain: '.' + process.env.CENTRAL_API_ROOT });

            } else if(Cookies.get(`userProfile`)) {
                data = {
                    data: {
                        data : JSON.parse(Cookies.get(`userProfile`))
                    }
                }  
            } else {
                data = await CentralApi.Auth.getUser('?without=profileData')
            }

            this.$store.dispatch("central/getUser", data);
            this.user = data.data.data;
        },
    },
    async mounted() {
        await this.getUser();
    },
    created(){

    }
};
</script>




// WEBPACK FOOTER //
// src/layouts/central/admin/TopMenu.vue